import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import RestoreIcon from '@material-ui/icons/Restore';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Hidden from '@material-ui/core/Hidden';
import Avatar from '@material-ui/core/Avatar';
import UpdateIcon from '@material-ui/icons/Update';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ListObjectiveModal from '../ListObjectiveModal';
import GeneralStatusAvailabilityConsolidated from '../GeneralStatus/GeneralStatusAvailabilityConsolidated';
import Period from '../../../../helpers/PeriodGeneralStatus';
import { Box, Dialog, Switch } from '@material-ui/core';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";

import moment from 'moment-timezone'
import 'moment/locale/es'  
import { FilterTags } from '../../../../components/TagsAtentus/FilterTags';
import queryString from 'query-string';
import compose from 'recompose/compose';
import { NavLink, withRouter } from 'react-router-dom';
import { createSelectedPeriodState, defaultPeriodsGeneralStatus } from '../../../../utils/fns/generate-period-state';
import AtSelectPeriod from '../../../../components/AtSelectPeriod/AtSelectPeriod';
import { format } from 'date-fns';
import { sidebarFiltersTags } from '../../../../utils/local-storage/sidebar-options';
import { getQueryParams } from '../../../../utils/fns/get-query-params';

moment.locale('es')

highchartsMore(Highcharts);
xRange(Highcharts);
Highcharts.setOptions({
    lang: {
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        weekdays: [
            'Domingo', 'Lunes', 'Martes', 'Miércoles',
            'Jueves', 'Viernes', 'Sábado'
        ]
    }
});

/**
 * Determina si el gráfico se actualizará de forma automática
 */
const autoRefreshSaved = localStorage.getItem('autoRefreshGeneralStatus')
const autoRefreshSavedValue = autoRefreshSaved === null || autoRefreshSaved === 'true'

const INTERVAL = 300000
const PERIODOS = ['hora', '3hora', '6hora', '12hora', 'dia', '2dia', 'semana', '2semana', 'mes', 'c']
const CLIENT_BBVA_AR = '5467' /*SOLO PARA ESTADO GENERAL BBVA*/

class GeneralStatus extends Component {

    constructor(props) {
        super(props);
        
        const parsed = queryString.parse(document.location.search);
        const etiquetas = parsed?.etiquetas && parsed?.etiquetas !== ''
            ? parsed?.etiquetas.split('T').map(e => Number(e)) ?? [] : [];

        const periodo = parsed?.periodo && parsed?.periodo !== '' && parsed?.periodo !== '0' && PERIODOS.includes(parsed?.periodo)
            ? parsed?.periodo : 'dia'
        
        const selectedPeriodState = createSelectedPeriodState(
            periodo || 'dia', 0, 
            {startDate: new Date(parsed.startDate), endDate: new Date(parsed.endDate)}
        )

        let active = defaultPeriodsGeneralStatus.filter(item => item.period === periodo ?? 'dia')[0]
        if (periodo === "c") {
            const startDate = new Date(`${parsed.startDate} 00:00`)
            const endDate = new Date(`${parsed.endDate} 23:59`)

            const text = `Custom: ${format(
                startDate,
                "dd/MM/yyyy"
              )} - ${format(endDate, "dd/MM/yyyy")}`;

            active = {
                value: "custom",
                statePeriod: {
                    startDate,
                    endDate,
                    key: "selection",
                },
                text,
                period: "c",
              }
        }

        const filterTypeFromStorage = sidebarFiltersTags.getFilterType();
        
        const filterType = parsed?.filterType ?? filterTypeFromStorage;

        this.state = {
            isOpen: false,
            path: null,
            listObjectives: {},
            nameStatus: 'Objetivos ',
            selectedOption: null,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: selectedPeriodState.period,
            period: selectedPeriodState.period,
            hoverData: null,
            lastEvent: [],
            isStatePeriod: false,
            settingsEl: null,
            isInfo: null,
            date: moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a"),
            objmodal: 0,
            objNameModal: '',
            openObjectiveModal: false,
            typeGraph: 0,
            namePeriod: null,
            namePeriodPorlet: ['Última Hora', 'Últimas 3 horas', 'Últimas 6 horas', 'Últimas 12 horas', 'Último día', 'Últimos 2 días', 'Última semana', 'Últimas 2 semanas', 'Último mes', 'Custom', 'Seleccione Período'],
            typePeriod: selectedPeriodState.typePeriod,
            chartOptionsBase: {...this._chartOptionsBase, series: selectedPeriodState.chartOptionsStackedBarConsolidated.series},
            chartOptionsStackedBarConsolidated: {...this._chartOptionsBase, series: selectedPeriodState.chartOptionsStackedBarConsolidated.series},
            isRefresh: false,
            intervalId: null,
            autoRefresh: autoRefreshSavedValue,
            filterTagsId: etiquetas,
            periodText: "dia",
            isSpecial: sessionStorage.getItem("client_id") === CLIENT_BBVA_AR ? true : false,
            statePeriod: active?.statePeriod,
            selectedPeriodState: active,
            nextPeriod: "dia",
            filterTagsType: filterType,
        }

    }

    _chartOptionsBase = {

        chart: {
            type: 'xrange',
            height: 50,
        },
        title: {
            text: null
        },
        xAxis: {
            type: 'datetime',
            gridLineWidth: 0,
        },
        pane: {
            size: '150%',
        },
        yAxis: {
            title: {
                text: ''
            },
            categories: [''],
            gridLineWidth: 0,
            reversed: true,
            labels: {
                useHTML:true,//set to true
                style:{
                    whiteSpace:'normal'//set to normal
                },
                step: 1,
                formatter: function () {//use formatter
                    var objNameLabel = this.value
                    return '<div align="initial" style="word-wrap: break-word;word-break: break-all;width:200px"></div>';
                }
            },
        },
        series: [{
            pointWidth: 40,
            turboThreshold: 0,
            animation: false,
            data: [{
                x: Date.UTC(2021, 2, 10,11,23,0),
                x2: Date.UTC(2021, 2, 10,12,23,0),
                y: 0,
                color: 'white'
            }]
        }],
       
        plotOptions: {
            series: {
                borderRadius: 0,
                borderColor: 'transparent',
                pointWidth: 10,
                turboThreshold: 0,
                grouping: false,
                datalabels: false,
                        cursor: 'pointer',
            }
        },
        credits: {
            enabled: false
        },
        tooltip: {
            xDateFormat: '%A, %b %e, %Y %H:%M:%S',
            enabled: false,
        },
        legend: {
            enabled: false
        },
    }
    
    setHoverData = (e) => {

        const { params } = this.state
        let name = e.point.name
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + name,
            listObjectives: params[name]
        });
    }
    setHoverDataBar = (e) => {

        const { params } = this.state
        const { category, series } = e.point
        let nameCat = category
        let nameStatus = series.name
        var filterParams = params[nameStatus].filter(param => param['grupo_servicio_unificado'] == nameCat)
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + nameCat,
            listObjectives: filterParams
        });
    }
    onOpenModal = () => {
        this.setState({ isOpen: true });
    };

    onCloseModal = () => {
        this.setState({ isOpen: false });
    };
    tick=()=>{
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        this.setState({
            loadObjectiveData: false,
            isLoading: true,
            settingsEl: null,
            isRefresh: true,
            date: moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a"),
        })
        this.processData()
      }

    componentDidMount() {
        this.processData()
        if (this.state.autoRefresh) {
            const newIntervalId = setInterval(() => this.tick(), INTERVAL);

            this.setState({ intervalId: newIntervalId });
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    processData = () => {
        const { params } = this.props;
        var data = params
        if((sessionStorage.getItem("listsLoads"))==="true"){
            data = JSON.parse(sessionStorage.getItem("listaData"))
        }
        return new Promise(resolve => {
            setTimeout(() => {
                
                const {chartOptionsBase} = this.state;
                const newChecked = chartOptionsBase;

                let objectivesList = []
                Object.keys(data).map((key) => {
                    if (key !== 'Services' && key !=='ServicesUnified' && key != 'NoMonitoringPartial') {
                        Object(data[key]).map((objective, orden)=>{
                            objectivesList.push(objective)
                        })
                    } 
                })
                var order = {'Downtime': 1, "Parcial": 2, "Uptime": 3, "No monitoreo": 4, "Marcado atentus": 5};
                objectivesList.sort(function (a, b) {
                    var priorityA = order[a.estado] || Infinity;
                    var priorityB = order[b.estado] || Infinity;

                    var nombreA = a.nombre.toLowerCase()
                    var nombreB = b.nombre.toLowerCase()

                    if (priorityA < priorityB) return -1;
                    if (priorityA > priorityB) return 1;

                    if (nombreA < nombreB) return -1;
                    if (nombreA > nombreB) return 1;
                    return 0;
                });

                this.setState({
                    objectivesList: objectivesList,
                    loadObjectiveData: true,
                    listObjetivesData: data,
                    isLoading: false,
                    params: data,
                    date: moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a"),
                    chartOptionsStackedBarConsolidated: newChecked,
                    period: this.state.time,
                    isRefresh: false
                });
                resolve(true);

            }, 2000);
        });

    }

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
    };
    
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleRefresh = () => {
        if (this.state.autoRefresh) {
            clearInterval(this.state.intervalId);
            const newIntervalId = setInterval(() => this.tick(), INTERVAL);
            this.setState({ intervalId: newIntervalId });
        }
        this.tick()
        this.setState({
            loadObjectiveData: false,
            isLoading: true,
            settingsEl: null,
            isRefresh: true
        });
    };
    handleDefault = () => {
        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed['periodo'] = 'dia';
        this.props.history.push({pathname: '/generalStatus', search: queryString.stringify(queryParamsParsed)});
    };

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };

    
    handleOpenObjectiveModal = event => {      
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value       
        if (this.state.openObjectiveModal == false){
            this.setState({
                openObjectiveModal: true,
                objIdModal: objId,
                objNameModal: objName
            })
        }        
    };
    
    handleCloseObjectiveModal  = event => {
        this.setState({
            openObjectiveModal: false,
        })
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    changeGlobalPeriod = ({ period, statePeriod }) => {
        const selectedPeriodState = createSelectedPeriodState(period, 0, statePeriod)
        this.setState({...selectedPeriodState, date: moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")});

        
        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["periodo"] = period;
        if (period === "c") {
            const startDate = statePeriod && moment(statePeriod.startDate).format("YYYY-MM-DD")
            const endDate = statePeriod && moment(statePeriod.endDate).format("YYYY-MM-DD")
            queryParamsParsed["startDate"] = startDate;
            queryParamsParsed["endDate"] = endDate;
        } else {
            delete queryParamsParsed["startDate"];
            delete queryParamsParsed["endDate"];
        }

        window.history.replaceState(
            null,
            "Estado General",
            `/generalStatus?${queryString.stringify(queryParamsParsed)}`
        );
    }

    handleChangeAutoRefresh = (event) => {
        const newValue = !Boolean(event.target.value === 'true')

        if (newValue) {
            clearInterval(this.state.intervalId);
            const newIntervalId = setInterval(() => this.tick(), INTERVAL);
            this.setState({ intervalId: newIntervalId });
        } else {
            clearInterval(this.state.intervalId)
        }
        localStorage.setItem('autoRefreshGeneralStatus', newValue)
        this.setState({ autoRefresh: newValue })
    }

    updateEtiquetas = (etiquetas, filterType) => {
        const ids = etiquetas.map(etiqueta => etiqueta.etiqueta_id)
        this.setState({filterTagsId: ids, filterTagsType: filterType})

        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["filterType"] = filterType;
        queryParamsParsed["etiquetas"] = ids.join('T');

        window.history.replaceState(
            null,
            "Estado General",
            `/generalStatus?${queryString.stringify(queryParamsParsed)}`
        );
    }

    objectivesListFilteredByTags = () => {
        if (this.state.filterTagsId.length === 0) return this.state.objectivesList
        let newListObjectives = []
        for (const state in this.state.listObjetivesData) {
            if(this.state.listObjetivesData[state]) {
                const filtered = this.state.listObjetivesData[state].filter(obj => {
                    if (!obj.Etiquetas) return false
                    let tieneEtiquetas = true

                    if (this.state.filterTagsType === "AND") {
                        for (const id of this.state.filterTagsId) {
                            if (!obj.Etiquetas.find(et => et.etiqueta_id === id)) {
                                tieneEtiquetas = false
                                break;
                            }
                        }
                    } else {
                        tieneEtiquetas = obj.Etiquetas.filter(et => this.state.filterTagsId.includes(et.etiqueta_id)).length
                    }
                    return tieneEtiquetas
                })
                newListObjectives = [...newListObjectives, ...filtered]
            }
        }
        return newListObjectives
    }

    changeIsSpecialSwitch = () => {
        this.setState((prevState) => ({
            isSpecial: !prevState.isSpecial,
          }));
    }

    render() {
        const { chartOptions, chartOptionsStackedBarConsolidated, isLoading, 
            date, settingsEl, loadObjectiveData, listObjetivesData,
            objIdModal, objNameModal, openObjectiveModal, periodEl, typeGraph, period, isOneHour, namePeriodPorlet, typePeriod, fromBoards} = this.state;
        const { classes, className, handleClose, isForModal } = this.props;
        const style = isLoading ? { display: 'none' } : {maxWidth:'100vw', padding:'0px'};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const rootClassName = classNames(classes.root, className);
        const showSettingsEl = Boolean(settingsEl);
        const objectivesListFilteredByTags = this.objectivesListFilteredByTags()
        
        let isForModalEl = false
        if (isForModal == true){
            isForModalEl = true
        }
        const isGlobal = sessionStorage.getItem("client_id") === CLIENT_BBVA_AR

        return (
            <Box className={rootClassName}>
                
                <PortletHeader className={classes.header} style={{borderBottom: "none"}}>
                        {fromBoards ? 
                            <div style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <NavLink to={{pathname: '/boards', search: getQueryParams()}}>
                                <Button 
                                style={{color: "#fff", background: "#909090"}}
                                >
                                    Regresar
                                </Button>
                                </NavLink>
                            </div>
                        :null}
                        <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                            <Hidden only={["xs", 'sm']}><Avatar variant="rounded" className={classes.rounded}>
                            <UpdateIcon /> 
                            </Avatar>
                            <Typography  className={classes.updateTime}   >
                                    &nbsp; Última actualización: {date} 
                            </Typography></Hidden>
                        </div>
                        <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                            <AtSelectPeriod
                                persistInStorage={false}
                                hideApplyToAll={true}
                                changePeriodFn={this.changeGlobalPeriod}
                                defaultPeriods={defaultPeriodsGeneralStatus}
                                activePeriodFromParent={this.state.selectedPeriodState}
                            />
                            <IconButton
                                onClick={this.handleShowSettings}
                                styles={{float:'right'}}
                            >
                                <SettingsOutlinedIcon />
                            </IconButton>
                            {isForModalEl ?
                                <IconButton 
                                    onClick={handleClose}
                                >
                                    <ClearIcon/>
                                </IconButton>
                            : null}
                        </div>
                    <Popover
                        anchorEl={settingsEl}
                        onClose={this.handleCloseSettings}
                        open={showSettingsEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                            }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                    }}
                    >
                        <IconButton color="primary" style={{display: 'flex', justifyContent: 'space-between', color:'#66788A'}} onClick={this.handleRefresh}>
                            <RefreshIcon color="primary" style={{ color:'#66788A'}} />
                            <Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>
                                Actualizar
                            </Typography>
                        </IconButton>
                        <IconButton color="primary" style={{display: 'flex', justifyContent: 'space-between'}} onClick={this.handleDefault}>
                            <RestoreIcon color="primary" style={{ color:'#66788A'}} />
                            <Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>
                                Periodo por Defecto
                            </Typography> 
                        </IconButton>
                        <Box display='flex'>
                            <Switch
                                value={this.state.autoRefresh}
                                checked={this.state.autoRefresh}
                                onChange={this.handleChangeAutoRefresh}
                                color="primary"
                                style={{margin: 0}}
                            />
                            <Box>
                                <Typography variant="h4" style={{fontSize:'15px', paddingLeft:'5px', color:'#66788A', marginBottom: -5}}>
                                    Auto refrescar
                                </Typography>
                                <Typography style={{fontSize: '10px', color:'#66788A', paddingLeft:'5px'}}>
                                    (5 mins.)
                                </Typography>
                            </Box>
                        </Box>           
                </Popover>
                </PortletHeader>
                <Grid container style={{paddingInline: 30}}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <FilterTags
                            listObjectives={[]}
                            updateEtiquetas={(etiquetas, filterType = "OR") => this.updateEtiquetas(etiquetas, filterType)}
                            tagsId={this.state.filterTagsId}
                            preload={true}
                            filterTagsType={this.state.filterTagsType}
                            showFilterType={true}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Box display='flex' alignItems='center' justifyContent='end'>
                            <Typography variant='h6' style={{color: "#6b6b6b"}}>
                            {isGlobal ? "Estado General Global" : "Estado General Especial"}
                            </Typography>
                            <Box style={{marginLeft: '10px', marginRight: '10px'}}>
                                <Switch
                                    checked={this.state.isSpecial}
                                    onChange={this.changeIsSpecialSwitch}
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    color='primary'
                                />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <PortletContent className={classes.content}>
                    {loadObjectiveData ?
                        <FormattedChart 
                            period={period}
                            handleOpen={this.handleOpenObjectiveModal}
                            listObjectives={objectivesListFilteredByTags} 
                            chartOptions={chartOptions} 
                            chartOptionsStackedBarConsolidated={chartOptionsStackedBarConsolidated} 
                            style={style} styleHidden={styleHidden} classes={classes} date={date}
                            isSpecial={this.state.isSpecial}
                            statePeriod={this.state.statePeriod}
                            />
                    :   <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                                <CircularProgress variant="indeterminate" size={24} thickness={4} />
                            </Grid>
                            <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                                    Cargando Información
                            </Grid>
                        </Grid>}
                        <Dialog
                        maxWidth='lg'
                        fullWidth
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={openObjectiveModal}
                        onClose={this.handleClose}
                        closeAfterTransition
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={openObjectiveModal}>                          
                            <ListObjectiveModal obj={objIdModal} objName={objNameModal} listObjectives={listObjetivesData} handleClose={this.handleCloseObjectiveModal}/>                        
                        </Fade>
                    </Dialog>
                </PortletContent>
                
            </Box>
        )
    }
}

function FormattedChart(props) {
    return ( 
        <div>
            <div style={props.style}>
                <Grid
                    container
                    style={{display: "flex", justifyContent: "center"}}
                >            
                    <Grid item
                        sm={12}
                        xl={12}
                        xs={12}
                        > 
                        <div style={{display: "flex", justifyContent: "center"}}>
                          <div style={{maxWidth:'80vw', minWidth:'80vw', marginLeft: 22, paddingRight: 22}}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={props.chartOptionsStackedBarConsolidated} />
                          </div>
                        </div>
                        <Grid item
                        sm={12}
                        xl={12}
                        xs={12}
                        >
                          <div style={{width: "100%"}}>
                            {props.period.length !=0 ? props.listObjectives.map(item => {
                                return (
                                    <div id={item.objetivo_id} key={item.objetivo_id} value={item.nombre} onClick={props.handleOpen} style={{display: "flex", justifyContent: "center", paddingBottom: "10px"}}>
                                        <GeneralStatusAvailabilityConsolidated objetivo_name={item.nombre} objetivo_id={item.objetivo_id} period={props.period} isSpecial={props.isSpecial} statePeriod={props.statePeriod} />
                                    </div>
                                )
                            }):"SELECCIONE PERÍODO"}
                          </div>
                        </Grid>
                    </Grid>     
                </Grid>     
            </div>   
        </div>           
    )
}

GeneralStatus.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default compose(withRouter, withStyles(styles))(GeneralStatus);
